exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-footer[data-v-23289674]{font-family:CoFo Sans;font-size:15px;font-weight:400;line-height:18px;letter-spacing:0;color:#abbcc1}.external-footer a[data-v-23289674],.external-footer span[data-v-23289674]{text-decoration:underline;color:#ff6f37!important;cursor:pointer}", ""]);

// exports
